import angular from 'angular';
import ComponentsModule from '../../../components-module';
import template from './accordion-item.html';
import Debug from 'ace-ui/ace-debug';

const COMPONENT_NAME = 'accordionItem';
const debug = new Debug (COMPONENT_NAME);

angular.module (ComponentsModule)
  .component (COMPONENT_NAME, {
    template,
    transclude: true,

    bindings: {
      expanded: '<',
      expandable: '<',
      highlight: '<',
      itemHeader: '@'
    },

    controller: ($scope, $element) => {
      let ctrl = $scope.$ctrl;

      ctrl.triggerReflow = () => {
        debug.log ('trigger reflow');
        const bell = $element.find('.head .bell');
        bell.removeClass('bell');
        bell.get().forEach((elem) => {
          debug.log ('triggering reflow', elem);
          void elem.offsetWidth;
        });
      
        bell.addClass('bell');
      };

      ctrl.toggle = () => {
        $element[0].dispatchEvent(new CustomEvent('toggle'));
      };

      ctrl.$postLink = () => {
        $element.addClass('bellow');
      };

      ctrl.$onInit = () => {
        if (ctrl.expandable === undefined) {
          ctrl.expandable = true;
        }
      };

      ctrl.$onChanges = ({ expanded, highlight }) => {
        if (expanded) {
          debug.log('$onChanges', { expanded, highlight });
          expanded.currentValue ? 
            $element.addClass('expanded')
            : $element.removeClass('expanded');
        }

        if (highlight && highlight.currentValue) {
          ctrl.triggerReflow();
        }
      };
    }
  });

export default COMPONENT_NAME;
